<script setup lang="ts">
// filepath: apps/frontend/src/App.vue
import { RouterView } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const authStore = useAuthStore();

// Initialize auth state on app load
authStore.initAuth();
</script>

<template>
  <RouterView />
</template>

<style>
/* App-level styles are in assets/styles/ */
</style>
